"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _warning = _interopRequireDefault(require("fbjs/lib/warning"));

var _fixedTop = _interopRequireDefault(require("../fixedTop"));

var _secondTop = _interopRequireDefault(require("../secondTop"));

var _sidebar = _interopRequireDefault(require("../sidebar"));

var _bottom = _interopRequireDefault(require("../bottom"));

var _mobileLayout = _interopRequireDefault(require("../mobileLayout"));

var _block = _interopRequireDefault(require("../block"));

var styles = _interopRequireWildcard(require("./styles/containerSwitch"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ContainerSwitch = function ContainerSwitch(_ref) {
  var containerName = _ref.containerName,
      width = _ref.width,
      blocks = _ref.blocks,
      fixedtop = _ref.fixedtop,
      secondtop = _ref.secondtop,
      sidebar = _ref.sidebar,
      fixedbottom = _ref.fixedbottom,
      children = _ref.children,
      product = _ref.product,
      useBottom = _ref.useBottom,
      flattenedWidgets = _ref.flattenedWidgets,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["containerName", "width", "blocks", "fixedtop", "secondtop", "sidebar", "fixedbottom", "children", "product", "useBottom", "flattenedWidgets"]);

  var fixedTopProps = _objectSpread(_objectSpread({}, props), fixedtop);

  var secondTopProps = _objectSpread(_objectSpread({}, props), secondtop);

  var sidebarProps = _objectSpread(_objectSpread({}, props), sidebar);

  var blockComponent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children || /*#__PURE__*/_react["default"].createElement(_block["default"], {
    flattenedWidgets: flattenedWidgets,
    width: width,
    blocks: blocks,
    product: product
  }), useBottom === false ? null : /*#__PURE__*/_react["default"].createElement(_bottom["default"], (0, _extends2["default"])({}, props, fixedbottom)));

  switch (containerName) {
    case 'DefaultContainer':
      return blockComponent;

    case 'FixedTopContainer':
      return /*#__PURE__*/_react["default"].createElement(_mobileLayout["default"], (0, _extends2["default"])({}, props, {
        fixedtop: fixedtop
      }), /*#__PURE__*/_react["default"].createElement(_fixedTop["default"], fixedTopProps), blockComponent);

    case 'TwoTopsContainer':
      return /*#__PURE__*/_react["default"].createElement(_mobileLayout["default"], (0, _extends2["default"])({}, props, {
        fixedtop: fixedtop,
        secondtop: secondtop
      }), /*#__PURE__*/_react["default"].createElement(_fixedTop["default"], fixedTopProps), /*#__PURE__*/_react["default"].createElement(_secondTop["default"], secondTopProps), blockComponent);

    case 'FixedTopContainerWithSidebar':
      return /*#__PURE__*/_react["default"].createElement(_mobileLayout["default"], (0, _extends2["default"])({}, props, {
        fixedtop: fixedtop,
        sidebar: sidebar
      }), /*#__PURE__*/_react["default"].createElement(_fixedTop["default"], fixedTopProps), /*#__PURE__*/_react["default"].createElement(_sidebar["default"], (0, _extends2["default"])({}, sidebarProps, {
        style: styles.hideSidebarInPhone
      }), blockComponent));

    case 'TwoTopsContainerWithSidebar':
      return /*#__PURE__*/_react["default"].createElement(_mobileLayout["default"], (0, _extends2["default"])({}, props, {
        fixedtop: fixedtop,
        secondtop: secondtop,
        sidebar: sidebar
      }), /*#__PURE__*/_react["default"].createElement(_fixedTop["default"], fixedTopProps), /*#__PURE__*/_react["default"].createElement(_secondTop["default"], secondTopProps), /*#__PURE__*/_react["default"].createElement(_sidebar["default"], (0, _extends2["default"])({}, sidebarProps, {
        style: styles.hideSidebarInPhone
      }), blockComponent));

    default:
      (0, _warning["default"])(process.env.NODE_ENV === 'production', "[component] ".concat(containerName, " does not exist."));
      return null;
    // for production
  }
};

ContainerSwitch.propTypes = {
  width: _propTypes["default"].number,
  containerName: _propTypes["default"].string.isRequired,
  blocks: _propTypes["default"].arrayOf(_propTypes["default"].shape({}).isRequired).isRequired,
  fixedtop: _propTypes["default"].shape({}).isRequired,
  secondtop: _propTypes["default"].shape({}).isRequired,
  sidebar: _propTypes["default"].shape({}).isRequired,
  fixedbottom: _propTypes["default"].shape({}).isRequired,
  children: _propTypes["default"].node
};
ContainerSwitch.defaultProps = {
  width: null,
  children: null
};
var _default = ContainerSwitch;
exports["default"] = _default;